import styled from 'styled-components'

export const Container = styled.div`
  background-color: #FFFFFF;
  width: 100%;
  border: ${({ selected }) => selected ? '2px solid #FFC100' : 'none'};
  box-shadow: ${({ selected }) => selected ? 'none' : '0px 2px 10px -6px #252525'};
  border-radius: 15px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  padding: 8px 12px;
  gap: 10px;
  cursor: ${({ clickable }) => clickable ? 'pointer' : 'default'};
  
  &:hover {
    background-color: ${({ clickable }) => clickable ? '#F7F7F7' : '#FFFFFF'};
  }
`

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 3px;
`

export const Image = styled.img`
  width: 54px;
  height: 54px;
  border: 1px solid #DDDDDD;
  border-radius: 15px;
`

export const InfoText = styled.p`
  font-size: 14px;
  text-align: left;
  line-height: 16px;
  color: #000000;
  margin: 0px;
`

export const SubTitle = styled(InfoText)`
  font-weight: bold;
`
